module.exports = __webpack_public_path__ + "static/media/mg-t1.365ca7b1.svg";